import ArchiveLayout from '@/layouts/ArchiveLayout';
import { POSTS_QUERY } from '@/lib/wordpress';

type Locale = 'en' | 'el';

const title: Record<Locale, string> = {
  en: 'Articles',
  el: 'Άρθρα',
};

const description: Record<Locale, string> = {
  en: 'Latest news, insights, and updates from our team.',
  el: 'Τελευταία νέα, insights και ενημερώσεις από την ομάδα μας.',
};

const eyebrow: Record<Locale, string> = {
  en: 'BLOG',
  el: 'BLOG',
};

const emptyState: Record<Locale, string> = {
  en: 'No articles available at the moment.',
  el: 'Δεν υπάρχουν διαθέσιμα άρθρα αυτή τη στιγμή.',
};

const ctaText: Record<Locale, string> = {
  en: 'Contact us',
  el: 'Επικοινωνήστε μαζί μας',
};

export default function PostsArchive() {
  return (
    <ArchiveLayout
      pageKey="posts"
      postType="posts"
      query={POSTS_QUERY}
      title={title}
      description={description}
      eyebrow={eyebrow}
      emptyState={emptyState}
      ctaText={ctaText}
    />
  );
}
